import * as React from 'react'

function SvgBodyCheckedIcon(props) {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <path
        d="m32.293 8.293 1.414 1.414L28 15.414l-3.707-3.707 1.414-1.414L28 12.586l4.293-4.293Z"
        fill="#2EC40B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29 3a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm-6 8a6 6 0 1 0 12 0 6 6 0 0 0-12 0Z"
        fill="#2EC40B"
      />
      <path
        d="M18.243 13h1.98c.16.701.4 1.371.713 2h-2.693a2 2 0 0 0-1.415.586l-1.479 1.479a4 4 0 0 1-2.044 1.094l-1.697.34A2 2 0 0 0 10 20.458v1.82l1.092.364A3.438 3.438 0 0 1 14.437 20h.063a3.501 3.501 0 0 1 3.465 3h5.07a3.501 3.501 0 0 1 3.465-3h.137a3.364 3.364 0 0 1 3.236 2.445l.127-.063v-2.437a8.948 8.948 0 0 0 2-.457v2.894a2 2 0 0 1-1.106 1.789l-.877.439A1.394 1.394 0 0 1 28 23.363C28 22.61 27.39 22 26.637 22H26.5a1.5 1.5 0 0 0-1.5 1.5v.071c0 .79-.64 1.429-1.429 1.429H17.43c-.79 0-1.429-.64-1.429-1.429V23.5a1.5 1.5 0 0 0-1.5-1.5h-.063c-.794 0-1.437.643-1.437 1.437 0 .96-.94 1.637-1.85 1.333l-1.782-.593A2 2 0 0 1 8 22.279v-1.82a4 4 0 0 1 3.216-3.922l1.697-.34a2 2 0 0 0 1.022-.546l1.48-1.48A4 4 0 0 1 18.242 13Z"
        fill="#000"
      />
      <path
        d="M22 17.5v-.843c.4.494.85.944 1.343 1.343H22.5a.5.5 0 0 1-.5-.5ZM17.854 16.146l-1.427 1.427a.25.25 0 0 0 .177.427H20.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-2.293a.5.5 0 0 0-.353.146ZM14.5 27a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM26.5 27a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
        fill="#000"
      />
    </svg>
  )
}

export default SvgBodyCheckedIcon
